import { useFormContext } from "react-hook-form";
import AddressFields from "../../../../AddressFields";
import { useContext, useEffect } from "react";
import { GeaoContext } from "../../../GeaoContextProvider";
import { AddressLabelsWithRequiredIndicator } from "../../../../../constants/AddressFieldLabels";

export default function AddressSection() {
    const { agencyInterview } = useContext(GeaoContext);
    const { register, setValue, watch } = useFormContext();

    const watchW9AddressSameAsAgencyPrimaryPhysical = watch("w9AddressSameAsAgencyPrimaryPhysical");
    const watchW9AddressSameAsAgencyPrimaryMailing = watch("w9AddressSameAsAgencyPrimaryMailing");

    useEffect(() => {
        if (watchW9AddressSameAsAgencyPrimaryPhysical) {
            setValue("w9AddressSameAsAgencyPrimaryMailing", false);

            if (agencyInterview) {
                setValue("addressLine1", agencyInterview.questionAnswers?.PrimaryPhysicalAddressStreetLine1?.answer?.toUpperCase());
                setValue("addressLine2", agencyInterview.questionAnswers?.PrimaryPhysicalAddressStreetLine2?.answer?.toUpperCase());
                setValue("zipCode", agencyInterview.questionAnswers?.PrimaryPhysicalAddressZipCode?.answer);
                setValue("city", agencyInterview.questionAnswers?.PrimaryPhysicalAddressCity?.answer?.toUpperCase());
                setValue("state", agencyInterview.questionAnswers?.PrimaryPhysicalAddressState?.answer?.toUpperCase());
            }
        }
    }, [watchW9AddressSameAsAgencyPrimaryPhysical]);

    useEffect(() => {
        if (watchW9AddressSameAsAgencyPrimaryMailing) {
            setValue("w9AddressSameAsAgencyPrimaryPhysical", false);

            if (agencyInterview) {
                setValue("addressLine1", agencyInterview.questionAnswers?.PrimaryMailingAddressStreetLine1?.answer?.toUpperCase());
                setValue("addressLine2", agencyInterview.questionAnswers?.PrimaryMailingAddressStreetLine2?.answer?.toUpperCase());
                setValue("zipCode", agencyInterview.questionAnswers?.PrimaryMailingAddressZipCode?.answer);
                setValue("city", agencyInterview.questionAnswers?.PrimaryMailingAddressCity?.answer?.toUpperCase());
                setValue("state", agencyInterview.questionAnswers?.PrimaryMailingAddressState?.answer?.toUpperCase());
            }
        }
    }, [watchW9AddressSameAsAgencyPrimaryMailing]);

    return <>
        <h3 className="margin-top margin-bottom">Address</h3>

        <fieldset className="form-field checkbox-group">
            <div className="checkbox-wrapper col-1" >
                <div className="label--description">
                    <input id="agency-physical-address-checkbox" type="checkbox" {...register("w9AddressSameAsAgencyPrimaryPhysical")} />
                    <label htmlFor="agency-physical-address-checkbox" className="checkbox"><span>Use Agency Primary Physical Address</span></label>
                </div>
                <div className="label--description">
                    <input id="same-principal-address-checkbox" type="checkbox" {...register("w9AddressSameAsAgencyPrimaryMailing")} />
                    <label htmlFor="same-principal-address-checkbox" className="checkbox"><span>Use Agency Primary Mailing Address</span></label>
                </div>
            </div>
        </fieldset>

        {!watchW9AddressSameAsAgencyPrimaryPhysical && !watchW9AddressSameAsAgencyPrimaryMailing && (
            <AddressFields
                labels={AddressLabelsWithRequiredIndicator}
            />
        )}
    </>;
}